import { render, staticRenderFns } from "./User-space.vue?vue&type=template&id=7a3e4f44&"
import script from "./User-space.vue?vue&type=script&lang=js&"
export * from "./User-space.vue?vue&type=script&lang=js&"
import style0 from "./User-space.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports